import Vue from "vue";
import Antd from "ant-design-vue";
import axios from "axios";
import vueAxios from "vue-axios";
import moment from "moment";
import marked from "marked";
import { VueReCaptcha } from "vue-recaptcha-v3";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "ant-design-vue/dist/antd.css";
import "./registerServiceWorker";

Vue.use(VueReCaptcha, { siteKey: "6LdYM9gUAAAAABTT89YAdexQ5TM9hGbVDgOtOmkC" });
Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use(vueAxios, axios);
Vue.use({
  install() {
    Vue.marked = marked;
    Vue.prototype.$marked = marked;
  },
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

Vue.filter("formatDate", (value) => {
  if (value) {
    // Check if the value matches the ISO 8601 format (e.g., "2022-10-15T02:12:46.388Z")
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value)) {
      const formattedDate = moment(value).format("DD/MM/YYYY");
      return formattedDate;
    }

    // Check if the value matches the DD/MM/YYYY format (e.g., "15/10/2022")
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      return value;
    }
  }
  return value;
});

Vue.filter("replaceUnderscore", (value) => {
  if (value) {
    return value.replace(/_/g, " ");
  }
  return value;
});
Vue.filter("removeEr", (value) => {
  if (value) {
    return value.substring(0, value.length - 2);
  }
  return value;
});
Vue.filter("removeKebabCase", (value) => {
  if (value) {
    return value.replace(/-/g, " ");
  }
  return value;
});
Vue.filter("removeEntities", (value) => {
  if (value) {
    let ret = value.replace(/&gt;/g, ">");
    ret = ret.replace(/&lt;/g, "<");
    ret = ret.replace(/&quot;/g, '"');
    ret = ret.replace(/&apos;/g, "'");
    ret = ret.replace(/&amp;/g, "&");
    ret = ret.replace(/<br ?\/?>/g, "");
    return ret;
  }
  return value;
});
Vue.mixin({
  data() {
    return {
      commonMenuItems: {
        admin: [
          {
            name: "Profile",
            icon: "user",
            routerLink: "/dashboard/my-profile",
            hide: false,
            hideForIr: false,
          },
          {
            name: "User List",
            icon: "team",
            routerLink: "/dashboard/telas-user",
            hide: false,
            hideForIr: false,
          },
          {
            name: "Courses",
            icon: "profile",
            routerLink: "/dashboard",
            hide: false,
            hideForIr: false,
          },
          {
            name: "Questionnaire Framework",
            icon: "setting",
            routerLink: "/dashboard/frameworks",
            hide: false,
            hideForIr: false,
          },
          {
            name: "Assessments",
            icon: "edit",
            routerLink: "/dashboard/assessments",
            hide: false,
            hideForIr: false,
            subMenu: [
              {
                name: "Assigned",
                icon: "edit",
                routerLink: "/assessments/assigned",
                hide: false,
                hideForIr: false,
                nameKey: "assigned",
              },
              {
                name: "In-Progress",
                icon: "edit",
                routerLink: "/assessments/in-progress",
                hide: false,
                hideForIr: false,
                nameKey: "in-progress",
              },
              {
                name: "Completed",
                icon: "edit",
                routerLink: "/assessments/completed",
                hide: false,
                hideForIr: false,
                nameKey: "completed",
              },
            ],
          },
          {
            name: "Combined Reviews",
            icon: "database",
            routerLink: "/dashboard/reports",
            hide: false,
            hideForIr: false,
          },
          {
            name: "Email Notifications",
            icon: "mail",
            routerLink: "/dashboard/email-notifications",
            hide: false,
            hideForIr: false,
          },
          {
            name: "New Course",
            icon: "form",
            routerLink: "/submit-course",
            hide: false,
            hideForIr: false,
          },
        ],
        courseSubmitters: [
          {
            name: "Profile",
            icon: "user",
            routerLink: "/dashboard/my-profile",
            hide: false,
            hideForIr: false,
          },
          {
            name: "Courses",
            icon: "profile",
            routerLink: "/dashboard",
            hide: false,
            hideForIr: false,
          },
          {
            name: "User List",
            icon: "team",
            routerLink: "/dashboard/telas-user",
            hide: false,
            hideForIr: false,
          },
        ],
        assessors: [
          {
            name: "Profile",
            icon: "user",
            routerLink: "/dashboard/my-profile",
            hide: false,
            hideForIr: false,
          },
          {
            name: "Assessments",
            icon: "edit",
            routerLink: "/dashboard",
            hide: false,
            hideForIr: false,
            subMenu: [
              {
                name: "Assigned",
                icon: "edit",
                routerLink: "/assessments/assigned",
                hide: false,
                hideForIr: false,
                nameKey: "assigned",
              },
              {
                name: "In-Progress",
                icon: "edit",
                routerLink: "/assessments/in-progress",
                hide: false,
                hideForIr: false,
                nameKey: "in-progress",
              },
              {
                name: "Completed",
                icon: "edit",
                routerLink: "/assessments/completed",
                hide: false,
                hideForIr: false,
                nameKey: "completed",
              },
            ],
          },
          {
            name: "Courses",
            icon: "profile",
            routerLink: "/dashboard/courses",
            hideForIr: false,
            hide: true,
          },
          {
            name: "Combined Reviews",
            icon: "database",
            routerLink: "/dashboard/reports",
            hide: false,
            hideForIr: true,
          },
        ],
      },
    };
  },
});
